module.exports = new __parcel__URL__("loader_ics.71e9b6da.gif").toString();